// import {
//   Box,
//   Button,
//   FormControl,
//   FormControlLabel,
//   MenuItem,
//   Modal,
//   Radio,
//   RadioGroup,
//   Select,
//   TextField,
// } from "@mui/material";
// import AddIcon from "@mui/icons-material/Add";
// import SearchAndSelect from "../../../shared/SearchAndSelect";
// import { style } from "../index";
// import { useCallback, useEffect, useState } from "react";
// import { API_URLS } from "../../../config/apiUrls";
// import axiosInstance from "../../../config/axios";
// import { toast } from "react-toastify";
// import { CustomIconButton } from "../../../shared/CustomIconButton";
// import { Add, Remove } from "@mui/icons-material";
// const AddProductVariant = ({
//   open,
//   setOpen,
//   ids,
//   setIds,
//   rowData,
//   setRowData,
//   storeId,
//   setProductId,
//   productId,
//   setSearchParams,
//   searchParams,
//   addvarientData,
//   productData,
//   colorVarient,
//   otherVarient,
//   storeVarient,
//   setCategory,
//   searchColor,
//   setSearchColor,
//   searchOther,
//   setSearchOther,
//   searchStorage,
//   setSearchStorage,

//   searchConnectvity,
//   setSearchConnectvity,
//   searchScreenSize,
//   setSearchScreenSize,

//   connectvityVarient,
//   screenVarient,
// }) => {
//   const handleOpen = useCallback(() => setOpen(true), [setOpen]);
//   const handleClose = () => {
//     hangleCancel();
//     setOpen(false);
//   };

//   const [colorId, setColorId] = useState("");

//   const [connectvityId, setConnectvityId] = useState("");
//   const [ScreenId, setScreenId] = useState("");
//   const [storageId, setStorageId] = useState("");
//   const [otherId, setOtherId] = useState("");
//   const [productName, setProductName] = useState("");
//   const [quantity, setQuantity] = useState("");
//   const [image, setImage] = useState("");
//   const [price, setPrice] = useState("");
//   const [mrp, setMrp] = useState("");
//   const [length, setlength] = useState("");
//   const [breadth, setbreadth] = useState("");
//   const [height, setheight] = useState("");
//   const [weight, setweight] = useState("");
//   const [rating, setrating] = useState("");
//   const [dealproduct, setdealproduct] = useState("");
//   const [recommended, setrecommended] = useState("");
//   const [dealstartdate, setdealstartdate] = useState("");
//   const [dealenddate, setdealenddate] = useState("");
//   const [return_allowed, setReturnAllowed] = useState(false);
//   const [replacement_allowed, setReplacementAllowed] = useState(false);
//   const [return_replacement_in_days, setReturnReplacementDays] = useState("");
//   const [is_preorder, setIsPreorder] = useState(false);

//   const [ean, setEan] = useState("");
//   const [googleMarchant, setGoogleMarchant] = useState(false);

//   const [links, setLinks] = useState([""]);

//   const handleAddField = () => {
//     setLinks([...links, ""]);
//   };

//   const handleRemoveField = (index) => {
//     if (links.length > 1) {
//       const updatedLinks = links.filter((_, i) => i !== index);
//       setLinks(updatedLinks);
//     }
//   };

//   const handleInputChange = (event, index) => {
//     const updatedLinks = [...links];
//     updatedLinks[index] = event.target.value;
//     setLinks(updatedLinks);
//   };

//   console.log(rowData, "wjegiwfweof9y");

//   const editFunctionality = useCallback(
//     (row) => {
//       handleOpen();
//       setIds(row?.id);
//       setPrice(row?.price);
//       setQuantity(row?.quantity);
//       setMrp(row?.mrp);
//       setStorageId(row?.storage_variant_value);
//       setProductId(row.product);
//       setOtherId(row?.other_variant_value);
//       setColorId(row?.color_variant_value);
//       setProductName(row?.product_variant_name);
//       setlength(row?.length ? row?.length : "");
//       setbreadth(row?.breadth ? row?.breadth : "");
//       setheight(row?.height ? row?.height : "");
//       setweight(row?.weight ? row?.weight : "");
//       setrating(row?.rating ? row?.rating : "");
//       setdealproduct(row?.deal_product ? "True" : "False");
//       setrecommended(row?.recommended ? "True" : "False");
//       setGoogleMarchant(row?.googleMarchant || false);
//       setdealstartdate(
//         row?.deal_start_date ? row?.deal_start_date?.slice(0, 10) : "",
//       );
//       setdealenddate(
//         row?.deal_end_date ? row?.deal_end_date?.slice(0, 10) : "",
//       );

//       setEan(row?.ean ? row?.ean : "");
//       setLinks(
//         row?.youtube_videos
//           ? row?.youtube_videos?.length > 0
//             ? row?.youtube_videos
//             : [""]
//           : null,
//       );

//       setReplacementAllowed(row?.replacement_allowed || false);

//       setReturnAllowed(row?.return_allowed || false);
//       setReturnReplacementDays(row?.return_replacement_in_days || "");
//       setIsPreorder(row?.is_preorder || false);
//       setScreenId(row?.screen_size_variant_value);
//       setConnectvityId(row?.connectivity_variant_value);
//     },
//     [handleOpen, setProductId],
//   );

//   useEffect(() => {
//     if (rowData?.length > 0) {
//       editFunctionality(rowData);
//     }
//   }, [editFunctionality, rowData]);
//   console.log(colorId, storageId, typeof otherId, "??????");
//   const hangleCancel = () => {
//     setRowData();
//     setPrice("");
//     setQuantity("");
//     setProductName("");
//     setProductId("");
//     setColorId("");
//     setStorageId("");
//     setOtherId("");
//     setQuantity("");
//     setMrp("");
//     setIds(null);
//     setlength("");
//     setbreadth("");
//     setheight("");
//     setweight("");
//     setrating("");
//     setdealproduct("");
//     setrecommended("");
//     setGoogleMarchant(false);
//     setdealstartdate("");
//     setdealenddate("");
//     setEan("");
//     setLinks([""]);
//     setSearchColor("");
//     setSearchStorage("");
//     setSearchOther("");
//     setSearchParams("");
//     setReplacementAllowed(false);
//     setReturnAllowed(false);
//     setReturnReplacementDays("");
//     setIsPreorder(false);
//     setSearchConnectvity("");
//     setSearchScreenSize("");
//     setConnectvityId("");
//     setScreenId("");
//   };

//   console.log("parse data", JSON.stringify(rowData?.youtube_videos));

//   const submitCategory = () => {
//     const filteredLinks = links.filter((link) => link.trim() !== "");
//     const reqbody = new FormData();
//     reqbody.append("product_variant_id", ids);
//     reqbody.append("store_id", storeId);
//     reqbody.append("product", productId || rowData?.product?.id);
//     reqbody.append(
//       "color_variant_value",
//       colorId || rowData?.color_variant_value?.id || "",
//     );
//     reqbody.append(
//       "storage_variant_value",
//       storageId || rowData?.storage_variant_value?.id || "",
//     );
//     reqbody.append(
//       "other_variant_value",
//       otherId || rowData?.other_variant_value?.id || "",
//     );

//     reqbody.append(
//       "connectivity_variant_value",
//       connectvityId || rowData?.connectivity_variant_value || "",
//     );
//     reqbody.append(
//       "screen_size_variant_value",
//       ScreenId || rowData?.screen_size_variant_value || "",
//     );
//     reqbody.append("quantity", quantity);
//     reqbody.append("product_variant_name", productName);
//     reqbody.append("variant_image", image || "");
//     reqbody.append("price", price);
//     reqbody.append("mrp", mrp);
//     reqbody.append("length", length);
//     reqbody.append("breadth", breadth);
//     reqbody.append("height", height);
//     reqbody.append("weight", weight);
//     reqbody.append("rating", rating);
//     reqbody.append("recommended", recommended);
//     reqbody.append("rating", rating);
//     reqbody.append("deal_product", dealproduct);
//     reqbody.append("deal_start_date", dealstartdate);
//     reqbody.append("merchant_product_status", googleMarchant);
//     reqbody.append("ean", ean);
//     reqbody.append("youtube_videos", JSON.stringify(filteredLinks));
//     reqbody.append("return_replacement_in_days", return_replacement_in_days);
//     reqbody.append("return_allowed", return_allowed ? "True" : "False");
//     reqbody.append(
//       "replacement_allowed",
//       replacement_allowed ? "True" : "False",
//     );
//     reqbody.append("is_preorder", is_preorder ? "True" : "False");

//     ids === null
//       ? axiosInstance
//           .post(`${API_URLS.productVariantApi}`, reqbody)
//           .then((response) => {
//             if (response.data.response_code === 200) {
//               toast.success(response.data.message);
//               setPrice("");
//               setQuantity("");
//               setProductName("");
//               setProductId("");
//               setColorId("");
//               setStorageId("");
//               setOtherId("");
//               setQuantity("");
//               setMrp("");
//               setlength("");
//               setbreadth("");
//               setheight("");
//               setweight("");
//               setrating("");
//               setdealproduct("");
//               setrecommended("");
//               setdealstartdate("");
//               setGoogleMarchant(false);
//               setdealenddate("");
//               handleClose();
//               addvarientData();
//               setEan("");
//               setLinks([""]);
//               setSearchColor("");
//               setSearchStorage("");
//               setSearchOther("");
//               setSearchParams("");
//               setReplacementAllowed(false);
//               setReturnAllowed(false);
//               setReturnReplacementDays("");
//               setIsPreorder(false);
//               setSearchConnectvity("");
//               setSearchScreenSize("");
//               setConnectvityId("");
//               setScreenId("");
//             } else {
//               toast.error(response.data.message);
//             }
//           })
//           .catch((error) => {
//             //
//           })
//       : axiosInstance
//           .put(`${API_URLS.productVariantApi}`, reqbody)
//           .then((response) => {
//             if (response.data.response_code === 200) {
//               toast.success(response.data.message);
//               setPrice("");
//               setQuantity("");
//               setProductName("");
//               setProductId("");
//               setColorId("");
//               setStorageId("");
//               setOtherId("");
//               setQuantity("");
//               setMrp("");
//               setlength("");
//               setbreadth("");
//               setheight("");
//               setweight("");
//               setrating("");
//               setdealproduct("");
//               setrecommended("");
//               setdealstartdate("");
//               setIds(null);
//               setdealenddate("");
//               setGoogleMarchant(false);
//               setRowData({});
//               handleClose();
//               addvarientData();
//               setEan("");
//               setLinks([""]);
//               setSearchColor("");
//               setSearchStorage("");
//               setSearchOther("");
//               setSearchParams("");
//               setReplacementAllowed(false);
//               setReturnAllowed(false);
//               setReturnReplacementDays("");
//               setIsPreorder(false);
//               setSearchConnectvity("");
//               setSearchScreenSize("");
//               setConnectvityId("");
//               setScreenId("");
//             } else {
//               toast.error(response.data.message);
//             }
//           })
//           .catch((error) => {
//             //
//           });
//   };

//   const onSelectProduct = (_, newValue) => {
//     setCategory(newValue.value2);
//     console.log("AAAAAAAAA", newValue);
//   };

//   return (
//     <>
//       <Button
//         size="small"
//         variant="outlined"
//         color="primary"
//         onClick={handleOpen}
//       >
//         <AddIcon />
//         Variant
//       </Button>
//       <Modal
//         open={open}
//         onClose={handleClose}
//         aria-labelledby="child-modal-title"
//         aria-describedby="child-modal-description"
//       >
//         <Box
//           sx={{ ...style, width: 830 }}
//           className="rounded-2xl !border-0 !h-[80vh] overflow-auto"
//         >
//           <div
//             id="child-modal-title "
//             className="!text-black !underline !font-bold !py-3 !text-center !text-xl"
//           >
//             {ids === null ? "Add Product Variant" : "Update Product Variant"}
//           </div>
//           <div className="flex w-full gap-x-3">
//             <div className="w-[48%]">
//               <div className="">Select Product :</div>
//               <SearchAndSelect
//                 size="small"
//                 className="mt-1"
//                 textValue={searchParams}
//                 setTextValue={setSearchParams}
//                 value={productId}
//                 setValue={setProductId}
//                 onChange={onSelectProduct}
//                 options={productData.map(({ title, id, main_category }) => {
//                   return {
//                     label: title,
//                     value: id,
//                     value2: main_category,
//                   };
//                 })}
//               />
//               <div className="mt-2">Select Color Variant :</div>
//               <SearchAndSelect
//                 name="colorId"
//                 className="mt-1"
//                 textValue={searchColor}
//                 setTextValue={setSearchColor}
//                 value={Number(colorId)}
//                 setValue={setColorId}
//                 options={colorVarient.map((item) => {
//                   return {
//                     label: item.value,
//                     value: item.id,
//                   };
//                 })}
//               />

//               <div className="mt-2">Select Connectivity Variant :</div>
//               <SearchAndSelect
//                 name="colorId"
//                 className="mt-1"
//                 textValue={searchConnectvity}
//                 setTextValue={setSearchConnectvity}
//                 value={Number(connectvityId)}
//                 setValue={setConnectvityId}
//                 options={connectvityVarient.map((item) => {
//                   return {
//                     label: item.value,
//                     value: item.id,
//                   };
//                 })}
//               />

//               <div className="mt-2">Image :</div>
//               <input
//                 size="small"
//                 multiple
//                 type="file"
//                 onChange={(event) => setImage(event.target.files[0])}
//                 className="!w-[100%] !mt-1 border rounded border-gray-300 p-1"
//                 name="image"
//               />
//               <div className="mt-2">Price :</div>
//               <TextField
//                 size="small"
//                 id="outlined-basic"
//                 value={price}
//                 onChange={(event) => setPrice(event.target.value)}
//                 className="!w-[100%] !mt-1"
//                 name="price"
//               />
//               <div className="mt-2">Quantity :</div>
//               <TextField
//                 size="small"
//                 id="outlined-basic"
//                 value={quantity}
//                 onChange={(event) => setQuantity(event.target.value)}
//                 className="!w-[100%] !mt-1"
//                 name="quantity"
//               />
//               <div className="mt-2">weight :</div>
//               <TextField
//                 type="int"
//                 size="small"
//                 id="outlined-basic"
//                 value={weight}
//                 onChange={(event) => setweight(event.target.value)}
//                 className="!w-[100%] !mt-1"
//                 name="weight"
//               />
//               <div className="mt-2">rating:</div>
//               <FormControl fullWidth>
//                 <Select
//                   labelId="demo-simple-select-label"
//                   id="demo-simple-select"
//                   size="small"
//                   className="mt-1"
//                   value={rating}
//                   onChange={(event) => setrating(event.target.value)}
//                   name="rating"
//                 >
//                   <MenuItem value={"1"}>1</MenuItem>
//                   <MenuItem value={"2"}>2</MenuItem>
//                   <MenuItem value={"3"}>3</MenuItem>
//                   <MenuItem value={"4"}>4</MenuItem>
//                   <MenuItem value={"5"}>5</MenuItem>
//                 </Select>
//               </FormControl>

//               <div className="mt-2">Deal Product:</div>
//               <FormControl fullWidth>
//                 <Select
//                   labelId="demo-simple-select-label"
//                   id="demo-simple-select"
//                   size="small"
//                   className="mt-1"
//                   value={dealproduct}
//                   onChange={(event) => setdealproduct(event.target.value)}
//                   name="deal_product"
//                 >
//                   <MenuItem value={"True"}> True</MenuItem>
//                   <MenuItem value={"False"}>False</MenuItem>
//                 </Select>
//               </FormControl>
//               <div className="mt-2">StartDate</div>
//               <TextField
//                 type="date"
//                 size="small"
//                 id="outlined-basic"
//                 value={dealstartdate}
//                 onChange={(event) => setdealstartdate(event.target.value)}
//                 className="!w-[100%] !mt-1"
//                 name="deal_start_date"
//               />

//               <div className="mt-2">YouTube Video Links</div>
//               <div className="!flex flex-col gap-y-2">
//                 {links?.map((link, index) => (
//                   <div key={index} className="flex items-center gap-x-2">
//                     <div className="w-[80%]">
//                       <TextField
//                         type="text"
//                         size="small"
//                         value={link}
//                         onChange={(event) => handleInputChange(event, index)}
//                         className="!w-[100%] !mt-1"
//                         name={`link-${index}`}
//                       />
//                     </div>

//                     {links?.length > 1 && index !== links?.length - 1 && (
//                       <CustomIconButton
//                         onClick={() => handleRemoveField(index)}
//                         className="!w-[10%] !bg-gray-400"
//                       >
//                         <Remove className="text-black" />
//                       </CustomIconButton>
//                     )}

//                     {index === links?.length - 1 && (
//                       <CustomIconButton
//                         onClick={handleAddField}
//                         className="!w-[10%] !bg-gray-400"
//                       >
//                         <Add className="text-black" />
//                       </CustomIconButton>
//                     )}
//                   </div>
//                 ))}
//               </div>

//               <div className="mt-2">Sync Google Marchant</div>
//               <RadioGroup
//                 row
//                 aria-labelledby="demo-row-radio-buttons-group-label"
//                 defaultValue={true}
//                 name="sync-google-merchant"
//                 value={googleMarchant}
//                 onChange={(event) =>
//                   setGoogleMarchant(event.target.value === "true")
//                 }
//               >
//                 <FormControlLabel
//                   value={false}
//                   control={<Radio />}
//                   label="No"
//                 />
//                 <FormControlLabel
//                   value={true}
//                   control={<Radio />}
//                   label="Yes"
//                 />
//               </RadioGroup>

//               <div className="mt-2">Return Allow</div>
//               <RadioGroup
//                 row
//                 aria-labelledby="demo-row-radio-buttons-group-label"
//                 defaultValue={true}
//                 name="sync-google-merchant"
//                 value={return_allowed}
//                 onChange={(event) =>
//                   setReturnAllowed(event.target.value === "true")
//                 }
//               >
//                 <FormControlLabel
//                   value={false}
//                   control={<Radio />}
//                   label="No"
//                 />
//                 <FormControlLabel
//                   value={true}
//                   control={<Radio />}
//                   label="Yes"
//                 />
//               </RadioGroup>
//             </div>

//             <div className="w-[48%]">
//               <div>Select Storage Variant :</div>
//               <SearchAndSelect
//                 size="small"
//                 className="mt-1"
//                 textValue={searchStorage}
//                 setTextValue={setSearchStorage}
//                 value={Number(storageId)}
//                 setValue={setStorageId}
//                 options={storeVarient.map((item) => {
//                   return {
//                     label: item.value + " | " + item.variant_name,
//                     value: item.id,
//                   };
//                 })}
//               />
//               <div className="mt-2">Select Other Variant :</div>
//               <SearchAndSelect
//                 size="small"
//                 className="mt-1"
//                 textValue={searchOther}
//                 setTextValue={setSearchOther}
//                 value={Number(otherId)}
//                 setValue={setOtherId}
//                 options={otherVarient.map((item) => {
//                   return {
//                     label: item.value + " | " + item.variant_name,
//                     value: item.id,
//                   };
//                 })}
//               />

//               <div className="mt-2">Select ScreenSize Variant :</div>
//               <SearchAndSelect
//                 name="colorId"
//                 className="mt-1"
//                 textValue={searchScreenSize}
//                 setTextValue={setSearchScreenSize}
//                 value={Number(ScreenId)}
//                 setValue={setScreenId}
//                 options={screenVarient.map((item) => {
//                   return {
//                     label: item.value,
//                     value: item.id,
//                   };
//                 })}
//               />

//               <div className="mt-2">Product Variant Name :</div>
//               <TextField
//                 size="small"
//                 id="outlined-basic"
//                 value={productName}
//                 onChange={(event) => setProductName(event.target.value)}
//                 className="!w-[100%] !mt-1"
//                 name="productName"
//               />
//               <div className="mt-2">MRP :</div>
//               <TextField
//                 size="small"
//                 id="outlined-basic"
//                 value={mrp}
//                 onChange={(event) => setMrp(event.target.value)}
//                 className="!w-[100%] !mt-1"
//                 name="MRP"
//               />
//               <div className="mt-2">Length :</div>
//               <TextField
//                 type="int"
//                 size="small"
//                 id="outlined-basic"
//                 value={length}
//                 onChange={(event) => setlength(event.target.value)}
//                 className="!w-[100%] !mt-1"
//                 name="length"
//               />
//               <div className="mt-2">Width :</div>
//               <TextField
//                 type="int"
//                 size="small"
//                 id="outlined-basic"
//                 value={breadth}
//                 onChange={(event) => setbreadth(event.target.value)}
//                 className="!w-[100%] !mt-1"
//                 name="breadth"
//               />
//               <div className="mt-2">height :</div>
//               <TextField
//                 size="small"
//                 id="outlined-basic"
//                 value={height}
//                 onChange={(event) => setheight(event.target.value)}
//                 className="!w-[100%] !mt-1"
//                 name="height"
//               />

//               <div className="mt-2">Recommended:</div>
//               <FormControl fullWidth>
//                 <Select
//                   labelId="demo-simple-select-label"
//                   id="demo-simple-select"
//                   size="small"
//                   className="mt-1"
//                   value={recommended}
//                   onChange={(event) => setrecommended(event.target.value)}
//                   name="recommended"
//                 >
//                   <MenuItem value={"True"}> True</MenuItem>
//                   <MenuItem value={"False"}>False</MenuItem>
//                 </Select>
//               </FormControl>
//               <div className="mt-2">EndDate</div>
//               <TextField
//                 type="date"
//                 size="small"
//                 id="outlined-basic"
//                 value={dealenddate}
//                 onChange={(event) => setdealenddate(event.target.value)}
//                 className="!w-[100%] !mt-1"
//                 name="deal_end_date"
//               />

//               <div className="mt-2">EAN</div>
//               <TextField
//                 type="text"
//                 size="small"
//                 id="ean"
//                 value={ean}
//                 onChange={(event) => setEan(event.target.value)}
//                 className="!w-[100%] !mt-1"
//                 name="ean"
//               />

//               <div className="mt-2">Pre Order</div>
//               <RadioGroup
//                 row
//                 aria-labelledby="demo-row-radio-buttons-group-label"
//                 defaultValue={true}
//                 name="sync-google-merchant"
//                 value={is_preorder}
//                 onChange={(event) =>
//                   setIsPreorder(event.target.value === "true")
//                 }
//               >
//                 <FormControlLabel
//                   value={false}
//                   control={<Radio />}
//                   label="No"
//                 />
//                 <FormControlLabel
//                   value={true}
//                   control={<Radio />}
//                   label="Yes"
//                 />
//               </RadioGroup>
//               <div className="mt-2">Repalcement Allow</div>
//               <RadioGroup
//                 row
//                 aria-labelledby="demo-row-radio-buttons-group-label"
//                 defaultValue={true}
//                 name="sync-google-merchant"
//                 value={replacement_allowed}
//                 onChange={(event) =>
//                   setReplacementAllowed(event.target.value === "true")
//                 }
//               >
//                 <FormControlLabel
//                   value={false}
//                   control={<Radio />}
//                   label="No"
//                 />
//                 <FormControlLabel
//                   value={true}
//                   control={<Radio />}
//                   label="Yes"
//                 />
//               </RadioGroup>
//               <div className="mt-2">Repalcement/Return Days</div>
//               <TextField
//                 type="number"
//                 placeholder="Enter Days for Return And Replacement"
//                 size="small"
//                 id="outlined-basic"
//                 value={return_replacement_in_days}
//                 onChange={(event) =>
//                   setReturnReplacementDays(event.target.value)
//                 }
//                 className="!w-[100%] !mt-1"
//                 name="deal_start_date"
//               />
//             </div>
//           </div>

//           <Button
//             onClick={handleClose}
//             variant="contained"
//             color="warning"
//             className="!py-2 !mt-3"
//           >
//             CANCEL
//           </Button>
//           <Button
//             variant="contained"
//             type="submit"
//             color="success"
//             className="!py-2 !px-5 !font-bold !mt-3 !float-right"
//             onClick={submitCategory}
//           >
//             {ids === null ? "ADD" : "UPDATE"}
//           </Button>
//         </Box>
//       </Modal>
//     </>
//   );
// };

// export default AddProductVariant;

import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  MenuItem,
  Modal,
  Radio,
  RadioGroup,
  Select,
  TextField,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SearchAndSelect from "../../../shared/SearchAndSelect";
import { style } from "../index";
import { useCallback, useEffect, useState } from "react";
import { API_URLS } from "../../../config/apiUrls";
import axiosInstance from "../../../config/axios";
import { toast } from "react-toastify";
import { CustomIconButton } from "../../../shared/CustomIconButton";
import { Add, Remove } from "@mui/icons-material";

const AddProductVariant = ({
  open,
  setOpen,
  ids,
  setIds,
  rowData,
  setRowData,
  storeId,
  setProductId,
  productId,
  setSearchParams,
  searchParams,
  addvarientData,
  productData,
  colorVarient,
  otherVarient,
  storeVarient,
  setCategory,
  searchColor,
  setSearchColor,
  searchOther,
  setSearchOther,
  searchStorage,
  setSearchStorage,
  searchConnectvity,
  setSearchConnectvity,
  searchScreenSize,
  setSearchScreenSize,
  connectvityVarient,
  screenVarient,
}) => {
  const handleOpen = useCallback(() => setOpen(true), [setOpen]);
  const handleClose = () => {
    hangleCancel();
    setOpen(false);
  };

  const [colorId, setColorId] = useState("");
  const [connectvityId, setConnectvityId] = useState("");
  const [ScreenId, setScreenId] = useState("");
  const [storageId, setStorageId] = useState("");
  const [otherId, setOtherId] = useState("");
  const [productName, setProductName] = useState("");
  const [quantity, setQuantity] = useState("");
  const [image, setImage] = useState("");
  const [price, setPrice] = useState("");
  const [mrp, setMrp] = useState("");
  const [length, setlength] = useState("");
  const [breadth, setbreadth] = useState("");
  const [height, setheight] = useState("");
  const [weight, setweight] = useState("");
  const [rating, setrating] = useState("");
  const [dealproduct, setdealproduct] = useState("");
  const [recommended, setrecommended] = useState("");
  const [dealstartdate, setdealstartdate] = useState("");
  const [dealenddate, setdealenddate] = useState("");
  const [return_allowed, setReturnAllowed] = useState(false);
  const [replacement_allowed, setReplacementAllowed] = useState(false);
  const [return_replacement_in_days, setReturnReplacementDays] = useState("");
  const [is_preorder, setIsPreorder] = useState(false);
  const [ean, setEan] = useState("");
  const [googleMarchant, setGoogleMarchant] = useState(false);
  const [links, setLinks] = useState([""]);

  // ── NEW: specifications key-value array ──────────────────────────
  const [specifications, setSpecifications] = useState([
    { key: "", value: "" },
  ]);

  // ── Spec handlers ────────────────────────────────────────────────
  const handleAddSpec = () =>
    setSpecifications((prev) => [...prev, { key: "", value: "" }]);

  const handleRemoveSpec = (index) => {
    if (specifications.length > 1)
      setSpecifications((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSpecChange = (index, field, value) =>
    setSpecifications((prev) => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [field]: value };
      return updated;
    });

  // ── YouTube link handlers ─────────────────────────────────────────
  const handleAddField = () => setLinks([...links, ""]);
  const handleRemoveField = (index) => {
    if (links.length > 1) setLinks(links.filter((_, i) => i !== index));
  };
  const handleInputChange = (event, index) => {
    const updatedLinks = [...links];
    updatedLinks[index] = event.target.value;
    setLinks(updatedLinks);
  };

  // ── editFunctionality ─────────────────────────────────────────────
  const editFunctionality = useCallback(
    (row) => {
      handleOpen();
      setIds(row?.id);
      setPrice(row?.price);
      setQuantity(row?.quantity);
      setMrp(row?.mrp);
      setStorageId(row?.storage_variant_value);
      setProductId(row.product);
      setOtherId(row?.other_variant_value);
      setColorId(row?.color_variant_value);
      setProductName(row?.product_variant_name);
      setlength(row?.length || "");
      setbreadth(row?.breadth || "");
      setheight(row?.height || "");
      setweight(row?.weight || "");
      setrating(row?.rating || "");
      setdealproduct(row?.deal_product ? "True" : "False");
      setrecommended(row?.recommended ? "True" : "False");
      setGoogleMarchant(row?.googleMarchant || false);
      setdealstartdate(
        row?.deal_start_date ? row?.deal_start_date?.slice(0, 10) : "",
      );
      setdealenddate(
        row?.deal_end_date ? row?.deal_end_date?.slice(0, 10) : "",
      );
      setEan(row?.ean || "");
      setLinks(row?.youtube_videos?.length > 0 ? row.youtube_videos : [""]);
      setReplacementAllowed(row?.replacement_allowed || false);
      setReturnAllowed(row?.return_allowed || false);
      setReturnReplacementDays(row?.return_replacement_in_days || "");
      setIsPreorder(row?.is_preorder || false);
      setScreenId(row?.screen_size_variant_value);
      setConnectvityId(row?.connectivity_variant_value);
      // ── populate specifications on edit ──
      setSpecifications(
        row?.key_features?.length > 0
          ? row.key_features
          : [{ key: "", value: "" }],
      );
    },
    [handleOpen, setProductId],
  );

  useEffect(() => {
    if (rowData?.length > 0) editFunctionality(rowData);
  }, [editFunctionality, rowData]);

  // ── Reset / Cancel ────────────────────────────────────────────────
  const hangleCancel = () => {
    setRowData();
    setPrice("");
    setQuantity("");
    setProductName("");
    setProductId("");
    setColorId("");
    setStorageId("");
    setOtherId("");
    setMrp("");
    setIds(null);
    setlength("");
    setbreadth("");
    setheight("");
    setweight("");
    setrating("");
    setdealproduct("");
    setrecommended("");
    setGoogleMarchant(false);
    setdealstartdate("");
    setdealenddate("");
    setEan("");
    setLinks([""]);
    setSearchColor("");
    setSearchStorage("");
    setSearchOther("");
    setSearchParams("");
    setReplacementAllowed(false);
    setReturnAllowed(false);
    setReturnReplacementDays("");
    setIsPreorder(false);
    setSearchConnectvity("");
    setSearchScreenSize("");
    setConnectvityId("");
    setScreenId("");
    // ── reset specifications ──
    setSpecifications([{ key: "", value: "" }]);
  };

  // ── Submit ────────────────────────────────────────────────────────
  const submitCategory = () => {
    const filteredLinks = links.filter((link) => link.trim() !== "");
    // filter empty spec rows
    const filteredSpecs = specifications.filter(
      (s) => s.key.trim() !== "" || s.value.trim() !== "",
    );

    const reqbody = new FormData();
    reqbody.append("product_variant_id", ids);
    reqbody.append("store_id", storeId);
    reqbody.append("product", productId || rowData?.product?.id);
    reqbody.append(
      "color_variant_value",
      colorId || rowData?.color_variant_value?.id || "",
    );
    reqbody.append(
      "storage_variant_value",
      storageId || rowData?.storage_variant_value?.id || "",
    );
    reqbody.append(
      "other_variant_value",
      otherId || rowData?.other_variant_value?.id || "",
    );
    reqbody.append(
      "connectivity_variant_value",
      connectvityId || rowData?.connectivity_variant_value || "",
    );
    reqbody.append(
      "screen_size_variant_value",
      ScreenId || rowData?.screen_size_variant_value || "",
    );
    reqbody.append("quantity", quantity);
    reqbody.append("product_variant_name", productName);
    reqbody.append("variant_image", image || "");
    reqbody.append("price", price);
    reqbody.append("mrp", mrp);
    reqbody.append("length", length);
    reqbody.append("breadth", breadth);
    reqbody.append("height", height);
    reqbody.append("weight", weight);
    reqbody.append("rating", rating);
    reqbody.append("recommended", recommended);
    reqbody.append("deal_product", dealproduct);
    reqbody.append("deal_start_date", dealstartdate);
    reqbody.append("deal_end_date", dealenddate);
    reqbody.append("merchant_product_status", googleMarchant);
    reqbody.append("ean", ean);
    reqbody.append("youtube_videos", JSON.stringify(filteredLinks));
    reqbody.append("return_replacement_in_days", return_replacement_in_days);
    reqbody.append("return_allowed", return_allowed ? "True" : "False");
    reqbody.append(
      "replacement_allowed",
      replacement_allowed ? "True" : "False",
    );
    reqbody.append("is_preorder", is_preorder ? "True" : "False");
    // ── specifications append ──
    reqbody.append("key_features", JSON.stringify(filteredSpecs));

    const resetAll = () => {
      setPrice("");
      setQuantity("");
      setProductName("");
      setProductId("");
      setColorId("");
      setStorageId("");
      setOtherId("");
      setMrp("");
      setlength("");
      setbreadth("");
      setheight("");
      setweight("");
      setrating("");
      setdealproduct("");
      setrecommended("");
      setdealstartdate("");
      setdealenddate("");
      setGoogleMarchant(false);
      setEan("");
      setLinks([""]);
      setSearchColor("");
      setSearchStorage("");
      setSearchOther("");
      setSearchParams("");
      setReplacementAllowed(false);
      setReturnAllowed(false);
      setReturnReplacementDays("");
      setIsPreorder(false);
      setSearchConnectvity("");
      setSearchScreenSize("");
      setConnectvityId("");
      setScreenId("");
      setSpecifications([{ key: "", value: "" }]);
    };

    const onSuccess = (response) => {
      if (response.data.response_code === 200) {
        toast.success(response.data.message);
        resetAll();
        if (ids !== null) {
          setIds(null);
          setRowData({});
        }
        handleClose();
        addvarientData();
      } else {
        toast.error(response.data.message);
      }
    };

    if (ids === null) {
      axiosInstance
        .post(`${API_URLS.productVariantApi}`, reqbody)
        .then(onSuccess)
        .catch(() => {});
    } else {
      axiosInstance
        .put(`${API_URLS.productVariantApi}`, reqbody)
        .then(onSuccess)
        .catch(() => {});
    }
  };

  const onSelectProduct = (_, newValue) => {
    setCategory(newValue.value2);
  };

  return (
    <>
      <Button
        size="small"
        variant="outlined"
        color="primary"
        onClick={handleOpen}
      >
        <AddIcon /> Variant
      </Button>

      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{ ...style, width: 830 }}
          className="rounded-2xl !border-0 !h-[80vh] overflow-auto"
        >
          <div className="!text-black !underline !font-bold !py-3 !text-center !text-xl">
            {ids === null ? "Add Product Variant" : "Update Product Variant"}
          </div>

          <div className="flex w-full gap-x-3">
            {/* ── LEFT COLUMN ── */}
            <div className="w-[48%]">
              <div>Select Product :</div>
              <SearchAndSelect
                size="small"
                className="mt-1"
                textValue={searchParams}
                setTextValue={setSearchParams}
                value={productId}
                setValue={setProductId}
                onChange={onSelectProduct}
                options={productData.map(({ title, id, main_category }) => ({
                  label: title,
                  value: id,
                  value2: main_category,
                }))}
              />

              <div className="mt-2">Select Color Variant :</div>
              <SearchAndSelect
                className="mt-1"
                textValue={searchColor}
                setTextValue={setSearchColor}
                value={Number(colorId)}
                setValue={setColorId}
                options={colorVarient.map((item) => ({
                  label: item.value,
                  value: item.id,
                }))}
              />

              <div className="mt-2">Select Connectivity Variant :</div>
              <SearchAndSelect
                className="mt-1"
                textValue={searchConnectvity}
                setTextValue={setSearchConnectvity}
                value={Number(connectvityId)}
                setValue={setConnectvityId}
                options={connectvityVarient.map((item) => ({
                  label: item.value,
                  value: item.id,
                }))}
              />

              <div className="mt-2">Image :</div>
              <input
                type="file"
                multiple
                onChange={(e) => setImage(e.target.files[0])}
                className="!w-[100%] !mt-1 border rounded border-gray-300 p-1"
              />

              <div className="mt-2">Price :</div>
              <TextField
                size="small"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                className="!w-[100%] !mt-1"
              />

              <div className="mt-2">Quantity :</div>
              <TextField
                size="small"
                value={quantity}
                onChange={(e) => setQuantity(e.target.value)}
                className="!w-[100%] !mt-1"
              />

              <div className="mt-2">Weight :</div>
              <TextField
                size="small"
                value={weight}
                onChange={(e) => setweight(e.target.value)}
                className="!w-[100%] !mt-1"
              />

              <div className="mt-2">Rating :</div>
              <FormControl fullWidth>
                <Select
                  size="small"
                  className="mt-1"
                  value={rating}
                  onChange={(e) => setrating(e.target.value)}
                >
                  {["1", "2", "3", "4", "5"].map((v) => (
                    <MenuItem key={v} value={v}>
                      {v}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <div className="mt-2">Deal Product :</div>
              <FormControl fullWidth>
                <Select
                  size="small"
                  className="mt-1"
                  value={dealproduct}
                  onChange={(e) => setdealproduct(e.target.value)}
                >
                  <MenuItem value="True">True</MenuItem>
                  <MenuItem value="False">False</MenuItem>
                </Select>
              </FormControl>

              <div className="mt-2">Start Date</div>
              <TextField
                type="date"
                size="small"
                value={dealstartdate}
                onChange={(e) => setdealstartdate(e.target.value)}
                className="!w-[100%] !mt-1"
              />

              {/* ── YouTube Links ── */}
              <div className="mt-2">YouTube Video Links</div>
              <div className="flex flex-col gap-y-2">
                {links?.map((link, index) => (
                  <div key={index} className="flex items-center gap-x-2">
                    <div className="w-[80%]">
                      <TextField
                        type="text"
                        size="small"
                        value={link}
                        onChange={(e) => handleInputChange(e, index)}
                        className="!w-[100%] !mt-1"
                      />
                    </div>
                    {links.length > 1 && index !== links.length - 1 && (
                      <CustomIconButton
                        onClick={() => handleRemoveField(index)}
                        className="!bg-gray-400"
                      >
                        <Remove className="text-black" />
                      </CustomIconButton>
                    )}
                    {index === links.length - 1 && (
                      <CustomIconButton
                        onClick={handleAddField}
                        className="!bg-gray-400"
                      >
                        <Add className="text-black" />
                      </CustomIconButton>
                    )}
                  </div>
                ))}
              </div>

              {/* ══════════════════════════════════════
                  NEW — Specifications Key-Value
              ══════════════════════════════════════ */}

              <div className="mt-2">Sync Google Merchant</div>
              <RadioGroup
                row
                value={googleMarchant}
                onChange={(e) => setGoogleMarchant(e.target.value === "true")}
              >
                <FormControlLabel
                  value={false}
                  control={<Radio />}
                  label="No"
                />
                <FormControlLabel
                  value={true}
                  control={<Radio />}
                  label="Yes"
                />
              </RadioGroup>

              <div className="mt-2">Return Allow</div>
              <RadioGroup
                row
                value={return_allowed}
                onChange={(e) => setReturnAllowed(e.target.value === "true")}
              >
                <FormControlLabel
                  value={false}
                  control={<Radio />}
                  label="No"
                />
                <FormControlLabel
                  value={true}
                  control={<Radio />}
                  label="Yes"
                />
              </RadioGroup>
            </div>

            {/* ── RIGHT COLUMN ── */}
            <div className="w-[48%]">
              <div>Select Storage Variant :</div>
              <SearchAndSelect
                size="small"
                className="mt-1"
                textValue={searchStorage}
                setTextValue={setSearchStorage}
                value={Number(storageId)}
                setValue={setStorageId}
                options={storeVarient.map((item) => ({
                  label: item.value + " | " + item.variant_name,
                  value: item.id,
                }))}
              />

              <div className="mt-2">Select Other Variant :</div>
              <SearchAndSelect
                size="small"
                className="mt-1"
                textValue={searchOther}
                setTextValue={setSearchOther}
                value={Number(otherId)}
                setValue={setOtherId}
                options={otherVarient.map((item) => ({
                  label: item.value + " | " + item.variant_name,
                  value: item.id,
                }))}
              />

              <div className="mt-2">Select ScreenSize Variant :</div>
              <SearchAndSelect
                className="mt-1"
                textValue={searchScreenSize}
                setTextValue={setSearchScreenSize}
                value={Number(ScreenId)}
                setValue={setScreenId}
                options={screenVarient.map((item) => ({
                  label: item.value,
                  value: item.id,
                }))}
              />

              <div className="mt-2">Product Variant Name :</div>
              <TextField
                size="small"
                value={productName}
                onChange={(e) => setProductName(e.target.value)}
                className="!w-[100%] !mt-1"
              />

              <div className="mt-2">MRP :</div>
              <TextField
                size="small"
                value={mrp}
                onChange={(e) => setMrp(e.target.value)}
                className="!w-[100%] !mt-1"
              />

              <div className="mt-2">Length :</div>
              <TextField
                size="small"
                value={length}
                onChange={(e) => setlength(e.target.value)}
                className="!w-[100%] !mt-1"
              />

              <div className="mt-2">Width :</div>
              <TextField
                size="small"
                value={breadth}
                onChange={(e) => setbreadth(e.target.value)}
                className="!w-[100%] !mt-1"
              />

              <div className="mt-2">Height :</div>
              <TextField
                size="small"
                value={height}
                onChange={(e) => setheight(e.target.value)}
                className="!w-[100%] !mt-1"
              />

              <div className="mt-2">Recommended :</div>
              <FormControl fullWidth>
                <Select
                  size="small"
                  className="mt-1"
                  value={recommended}
                  onChange={(e) => setrecommended(e.target.value)}
                >
                  <MenuItem value="True">True</MenuItem>
                  <MenuItem value="False">False</MenuItem>
                </Select>
              </FormControl>

              <div className="mt-2">End Date</div>
              <TextField
                type="date"
                size="small"
                value={dealenddate}
                onChange={(e) => setdealenddate(e.target.value)}
                className="!w-[100%] !mt-1"
              />

              <div className="mt-2">EAN</div>
              <TextField
                type="text"
                size="small"
                value={ean}
                onChange={(e) => setEan(e.target.value)}
                className="!w-[100%] !mt-1"
              />

              <div className="mt-2">Pre Order</div>
              <RadioGroup
                row
                value={is_preorder}
                onChange={(e) => setIsPreorder(e.target.value === "true")}
              >
                <FormControlLabel
                  value={false}
                  control={<Radio />}
                  label="No"
                />
                <FormControlLabel
                  value={true}
                  control={<Radio />}
                  label="Yes"
                />
              </RadioGroup>

              <div className="mt-2">Replacement Allow</div>
              <RadioGroup
                row
                value={replacement_allowed}
                onChange={(e) =>
                  setReplacementAllowed(e.target.value === "true")
                }
              >
                <FormControlLabel
                  value={false}
                  control={<Radio />}
                  label="No"
                />
                <FormControlLabel
                  value={true}
                  control={<Radio />}
                  label="Yes"
                />
              </RadioGroup>

              <div className="mt-2">Replacement / Return Days</div>
              <TextField
                type="number"
                size="small"
                placeholder="Enter Days for Return And Replacement"
                value={return_replacement_in_days}
                onChange={(e) => setReturnReplacementDays(e.target.value)}
                className="!w-[100%] !mt-1"
              />
            </div>
          </div>

          <div className="mt-4 font-semibold text-gray-700">
            Specifications (Key - Value)
          </div>
          <div className="flex flex-col gap-y-2 mt-1">
            {specifications.map((spec, index) => (
              <div key={index} className="flex items-center gap-x-2">
                {/* Key */}
                <TextField
                  size="small"
                  placeholder="Key (e.g. RAM)"
                  value={spec.key}
                  onChange={(e) =>
                    handleSpecChange(index, "key", e.target.value)
                  }
                  className="!w-[42%]"
                />
                {/* Value */}
                <TextField
                  size="small"
                  placeholder="Value (e.g. 8 GB)"
                  value={spec.value}
                  onChange={(e) =>
                    handleSpecChange(index, "value", e.target.value)
                  }
                  className="!w-[42%]"
                />
                {/* Remove — all rows except last */}
                {specifications.length > 1 &&
                  index !== specifications.length - 1 && (
                    <CustomIconButton
                      onClick={() => handleRemoveSpec(index)}
                      className="!bg-gray-400"
                    >
                      <Remove className="text-black" />
                    </CustomIconButton>
                  )}
                {/* Add — only last row */}
                {index === specifications.length - 1 && (
                  <CustomIconButton
                    onClick={handleAddSpec}
                    className="!bg-gray-400"
                  >
                    <Add className="text-black" />
                  </CustomIconButton>
                )}
              </div>
            ))}
          </div>

          {/* ── Buttons ── */}
          <Button
            onClick={handleClose}
            variant="contained"
            color="warning"
            className="!py-2 !mt-3"
          >
            CANCEL
          </Button>
          <Button
            variant="contained"
            type="submit"
            color="success"
            className="!py-2 !px-5 !font-bold !mt-3 !float-right"
            onClick={submitCategory}
          >
            {ids === null ? "ADD" : "UPDATE"}
          </Button>
        </Box>
      </Modal>
    </>
  );
};

export default AddProductVariant;
